import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { isEmptyObject } from '../../../../../../../core/util/object';
import { isEmptyString } from '../../../../../../../core/util/string';
import {
  POKITDOK_CODE_URGENT_CARE,
  TYPE_SELF,
  TYPE_SKIP,
  VOID_LOCATION,
} from '../../../../../../../constants/index';
import {
  npiCheckError,
  npiCheckReceived,
  npiCheckSubmitted,
} from '../../../../../../../actions/npi';
import {
  insuranceDetailsError,
  insuranceDetailsReceived,
  insuranceDetailsSubmitting,
} from '../../../../../../../ducks/insurance/details';
import { getInsuranceDetailsUrl } from '../../../../../../../core/dapi/insuranceProfile';
import { getAccountSummaryById } from '../../../../../../../core/dapi/account';
import { apiGetDispatchable, apiPostDispatchable } from '../../../../../../../core/dapi';
import { accountSummaryError, receiveAccountSummary } from '../../../../../../../actions/account';
import { getNpiCheckUrl } from '../../../../../../../core/dapi/npi';
import useSelectInsuranceProfile from '../../../../../hooks/useSelectInsuranceProfile';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import { PROFILE_REFRESH_INSURANCE } from '../../../../../../../core/analytics/events';

export default (userProfileId: any, handleCloseMenu: any) => {
  const dispatch = useDispatch();
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);

  return useCallback(
    (event) => {
      event.stopPropagation();
      handleCloseMenu();

      // minimum data to submit npi check
      if (
        !userProfileId ||
        isEmptyObject(insuranceProfile) ||
        !insuranceProfile.member_code ||
        !insuranceProfile.insurer_name ||
        !insuranceProfile.first_name ||
        !insuranceProfile.last_name ||
        !insuranceProfile.birth_date
      ) {
        return;
      }

      analyticsTrackEvent(PROFILE_REFRESH_INSURANCE, { userProfileId });

      // wild guess, there's a weird bug where if you upload your insurance,
      // then make a booking, we'll update your insurance to be "self pay",
      // which is great for the clinic but if we have all your insurance info we should still
      // show you what we have
      let insurerType = insuranceProfile && insuranceProfile.insurer_type;
      if ([TYPE_SKIP, TYPE_SELF].includes(insuranceProfile.insurer_type)) {
        insurerType = 'PPO';
      }

      dispatch(npiCheckSubmitted(VOID_LOCATION));
      const postData = {
        member_code: insuranceProfile.member_code,
        insurer_name: insuranceProfile.insurer_name,
        plan_type: insurerType,
        first_name: insuranceProfile.first_name,
        last_name: insuranceProfile.last_name,
        birth_date: insuranceProfile.birth_date,
        insurance_profile_id: insuranceProfile.insurance_profile_id,
        user_profile_id: userProfileId,
      };

      if (!isEmptyString(insuranceProfile.card_front)) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'image_id' does not exist on type '{ memb... Remove this comment to see the full error message
        postData.image_id = insuranceProfile.card_front;
      }

      if (!isEmptyString(insuranceProfile.insurer_code)) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'insurer_code' does not exist on type '{ ... Remove this comment to see the full error message
        postData.insurer_code = insuranceProfile.insurer_code;
      }

      const onSuccess = (response: any) => {
        dispatch(insuranceDetailsSubmitting(true));

        const detailsUrl = getInsuranceDetailsUrl(
          response.eligibility_requests_id,
          insuranceProfile.insurance_profile_id,
          [POKITDOK_CODE_URGENT_CARE]
        );

        const onSuccess = (response: any) => {
          dispatch(insuranceDetailsSubmitting(false));

          const url = getAccountSummaryById(insuranceProfile.account_id);
          dispatch(apiGetDispatchable(url, receiveAccountSummary, accountSummaryError));

          return insuranceDetailsReceived(response, userProfileId);
        };

        const onError = (response: any) => {
          dispatch(insuranceDetailsSubmitting(false));
          return insuranceDetailsError(response);
        };

        dispatch(apiGetDispatchable(detailsUrl, onSuccess, onError));

        return npiCheckReceived(response);
      };

      const onError = (response: any) => {
        dispatch(insuranceDetailsSubmitting(false));
        dispatch(npiCheckError(response));
      };

      dispatch(apiPostDispatchable(getNpiCheckUrl(), postData, onSuccess, onError));
    },
    [dispatch, handleCloseMenu, insuranceProfile, userProfileId]
  );
};
